export enum BlockType {
  START = '__START__',
  APPOINTMENT = 'appointment',
  GENERAL = 'general',
  // SUPPORT = 'support',
  COMPLAINT = 'complaint',
  TRANSFER = 'transfer',
  SEND_MESSAGE = 'send_message',
  CUSTOM = 'custom',
}

export interface NodeType {
  id: string;
  type: BlockType;
  position: { x: number; y: number };
  context?: string;
  parentId?: string | null;
  children?: string[];
  intentCriteria?: string;
}

export interface EdgeType {
  id: string;
  source: string;
  target: string;
}
